import { combineReducers } from '@reduxjs/toolkit';
import usCasesByCounty from './usCasesByCounty.js';

export default combineReducers({
  usCasesByCounty,
});
